import React, { useMemo, useEffect } from "react";
import { useAuthenticated } from "../hooks/useAuthenticated";
import { useLocation, Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useCookies } from "react-cookie";
import { useDispatch } from "react-redux";
import { fetchAccessData } from "../store/slices/accessSlice";
import { useSelector } from "react-redux";

const AuthGuard = (props) => {
  const dispatch = useDispatch();
  const [cookies] = useCookies(["va", "euid"]);
  const accessData = useSelector((state) => state.accessDetails?.accessData);
  const isAdmin = accessData?.role?.label === "Admin";

  const { children, allowed } = props;
  const auth = useAuthenticated();
  // const auth = true
  const location = useLocation();

  // const hasPermission = useMemo(() => {

  //   let currentRoute = routePermissions.find(rp => rp.route === location.pathname);

  //   if (!currentRoute) {
  //     currentRoute = routePermissions.find(rp => {
  //       const regex = new RegExp(`^${rp.route?.replace(/\/:.*$/, '/[^/]+')}$`);
  //       return regex.test(location.pathname);
  //     });
  //   }

  //   // If still no match, check for a prefix match
  //   if (!currentRoute) {
  //     currentRoute = routePermissions
  //       .filter(rp => location.pathname?.startsWith(rp.route))
  //       .sort((a, b) => b.route.length - a.route.length)[0];
  //   }

  //   return currentRoute ? currentRoute.permission : true;
  // }, [location.pathname, routePermissions]);

  // if (!hasPermission) {
  //   return <Navigate to="/dashboard/not-found" />; // Redirect to a "no access" page
  // }

  useEffect(() => {
    if (cookies.euid) {
      dispatch(fetchAccessData(cookies.euid));
    }
  }, [dispatch, cookies.euid]);

  if (!auth) {
    const params = new URLSearchParams(location.search);
    const accessedFrom = params
      .get("accessedFrom")
      ?.replace(/['"]+/g, "")
      .trim(); // Remove any quotes

    if (accessedFrom === "email") {
      // Feed the original destination into the same ?redirect= relay that
      // GuestGuard/loginWithOtp already use to send the user back here
      // once they finish logging in.
      const target = `${location.pathname}${location.search}`;
      return <Navigate to={`/auth?redirect=${encodeURIComponent(target)}`} />;
    }

    return <Navigate to="/auth" />;
  }
  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
